import Value from "aldoo-ra/Value"
import { PermissionAPI } from "./api"

/**
 * Check if current user has permission (direct API call)
 * @param {string} permission - Permission to check
 * @returns {Promise<boolean>}
 */
export const hasPermission = async (permission) => {
  const [auth] = Value("user-credentials")
  if (!auth?._id) return false
  
  return await PermissionAPI.hasPermission(auth._id, permission)
}

/**
 * Check if current user has any of the permissions
 * @param {Array<string>} permissions - Array of permissions to check
 * @returns {Promise<boolean>}
 */
export const hasAnyPermission = async (permissions) => {
  const [auth] = Value("user-credentials")
  if (!auth?._id) return false
  
  return await PermissionAPI.hasPermission(auth._id, permissions)
}

/**
 * Check if current user has all permissions
 * @param {Array<string>} permissions - Array of permissions to check
 * @returns {Promise<boolean>}
 */
export const hasAllPermissions = async (permissions) => {
  const [auth] = Value("user-credentials")
  if (!auth?._id) return false
  
  // Check each permission individually
  const results = await Promise.all(
    permissions.map(perm => PermissionAPI.hasPermission(auth._id, perm))
  )
  return results.every(result => result === true)
}

/**
 * Get current user's permissions
 * @returns {Promise<Array<string>>}
 */
export const getUserPermissions = async () => {
  const [auth] = Value("user-credentials")
  if (!auth?._id) return []
  
  return await PermissionAPI.getUserPermissions(auth._id)
}